import { z } from 'zod';
import type { $brand } from 'zod/v4/core';

export type ClientId = string & $brand<'ClientId'>;
export const clientIdSchema = z.uuid().transform((id) => id as ClientId);

export type SessionId = string & $brand<'SessionId'>;
export const sessionIdSchema = z.uuid().transform((id) => id as SessionId);

export type SessionChargeId = string & $brand<'SessionChargeId'>;
export const sessionChargeIdSchema = z.uuid().transform((id) => id as SessionChargeId);

export type PaymentId = string & $brand<'PaymentId'>;
export const paymentIdSchema = z.uuid().transform((id) => id as PaymentId);

export type RefundId = string & $brand<'RefundId'>;
export const refundIdSchema = z.uuid().transform((id) => id as RefundId);
